import React from 'react';
import { withRouter } from 'react-router-dom';

import webSurveyLogo from '../../../assets/img/web-survey-logo.svg';

import styles from './AppBar.module.css';
/* global localStorage */

const BufflBar = ({
  builder = false,
  hideBufflLogo,
  customThemeImage,
  isTesting
}) => (
  <header
    className={`${styles.appBarContainer} ${
      builder ? styles.appBarBuilder : ''
    }`}
    style={isTesting() ? { marginTop: '40px' } : {}}
  >
    <div className={styles.webSurveyLogoContainer}>
      {(!customThemeImage ||
        (customThemeImage &&
          customThemeImage.NAME &&
          customThemeImage.IMAGE &&
          customThemeImage.IMAGE === 'default')) &&
      !hideBufflLogo ? (
        <img
          src={webSurveyLogo}
          alt="BUFFL | Web Survey"
          className={styles.webSurveyLogo}
        />
      ) : null}

      {customThemeImage &&
      customThemeImage.IMAGE &&
      customThemeImage.IMAGE !== 'default' ? (
        <img
          src={customThemeImage.IMAGE}
          alt="BUFFL | Web Survey"
          className={styles.webSurveyCustomLogo}
        />
      ) : null}
    </div>
  </header>
);

export default withRouter(BufflBar);
